import React from 'react';

const ContentGamesTableHeader = ({ cl }) => {
  return (
    <div className={cl.tableHeader}>
      <div>Data</div>
      <div>Home</div>
      <div> </div>
      <div>Guests</div>
      <div> </div>
      <div>Inn</div>
    </div>
  );
};

export default ContentGamesTableHeader;
